<ng-container *ngIf="viewModel$ | async as vm">
  <p-blockUI [target]="blockable" [blocked]="vm.loading" [autoZIndex]="false">
    <i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i>
  </p-blockUI>
  <div class="dashboard-card activity">
    <div class="dashboard-card-header p-mb-4">
      <div>
        <h4 class="p-mb-1">Activity<app-error-icon *ngIf="vm.error" [error]="vm.error"></app-error-icon></h4>
        {{ vm.displayPeriod }}
      </div>
      <app-dashboard-info-v2>
        <div class="p-mb-2">
          <b>Payments:</b> For each day of the selected period, the cumulative sum of the payments matching the Status and Anchor Point filters, stacked by provider.
        </div>
        <div class="p-mb-2">
          <a [routerLink]="['/reports', 'dynamic', 'new']" [queryParams]="vm.queryParams.transactions" target="_blank">View Report</a>.
        </div>
        <div class="p-mb-2">
          <b>Created Events:</b> For each day of the selected period, the cumulative sum of discounted subtotal of all events created on that day.
        </div>
        <div class="p-mb-2">
          <a [routerLink]="['/reports', 'dynamic', 'new']" [queryParams]="vm.queryParams.eventsCreated" target="_blank">View Report</a>.
        </div>
        <div class="p-mb-2">
          <b>Scheduled Events:</b> For each day of the selected period, the cumulative sum of discounted subtotal of all events happening on that day.
        </div>
        <div class="p-mb-2">
          <a [routerLink]="['/reports', 'dynamic', 'new']" [queryParams]="vm.queryParams.eventsHappening" target="_blank">View Report</a>.
        </div>
      </app-dashboard-info-v2>
    </div>
    <app-blockable #blockable>
      <p-chart
        type="bar"
        [data]="vm.graphData"
        [options]="vm.options"
        [responsive]="true"
        height="200px"
        ></p-chart>
    </app-blockable>
  </div>
</ng-container>
